<template>
    <div :class="['modal_overlay fixed', { 'show': appStore.loginModalVisible }]" @click.self="appStore.closeLogin()">
        <!-- 登录弹窗 -->
        <div v-show="appStore.loginView == 'login'" class="login_card absolute flex flex-col items-center">
            <img class="login_close absolute pointer" src="@/assets/global/login_close.png" alt=""
                @click="appStore.closeLogin()">
            <div class="card_top w-full flex-center flex-col">
                <img class="top_icon" src="@/assets/global/login_wx_icon.png" alt="">
                <div class="top_title b">微信扫码登录</div>
                <div class="top_desc">使用微信扫一扫，安全快速登录</div>
            </div>
            <div class="card_bottom flex-center flex-col">
                <div class="bottom_qrcode flex-center relative">
                    <img class="qrcode" :src="appStore.loginQRCode" alt="">
                    <div v-if="appStore.isLoginReset" class="code_reset absolute flex-center w-full h-full"
                        @click="appStore.SET_isLoginReset(false); appStore.openLogin()">
                        <div class="reset w-full h-full flex-center flex-col pointer">
                            <img class="reset_img mb5" src="@/assets/global/qrcode_reset.png" alt="">
                            <div class="reset_text">点击刷新</div>
                        </div>
                    </div>
                </div>
                <div class="bottom_tip ac">打开微信 → 点击右上角 <span>+</span> → 选择 <span>扫一扫</span> 扫描上方二维码完成登录</div>
                <div class="bottom_about">
                    登录即代表您同意 <span @click="jumpUrl('userAgreement')">用户协议</span> 与 <span
                        @click="jumpUrl('privacyPolicy')">隐私政策</span>
                </div>
            </div>
        </div>
        <!-- 登录成功提示 -->
        <div v-show="appStore.loginView == 'success'" class="login_success_screen flex-center flex-col absolute">
            <img class="success_ico" src="@/assets/global/login_success.png" alt="">
            <div class="success_name b f12">{{ appStore.UserInfo?.nickname }}·登录成功</div>
            <div class="success_msg">欢迎回来！您现在可以购买商品了</div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { track } from "@/utils/track";
const appStore = useAppStore();

// tips onMounted
onMounted(() => {
    // 进入登录页埋点
    track("login");
})

// 跳转用户协议和隐私政策
let jumpUrl = (type) => {
    appStore.MyWin.WorkAiApi("client_open_url", `http://workai.zhuazi.com/${type}.html`);
}
</script>

<style lang="less" scoped>
.modal_overlay {
    inset: 0;
    background: rgba(0, 0, 0, .52);
    z-index: 1000;
    padding: 16px;
    opacity: 0;
    pointer-events: none;
    transition: opacity .25s;

    &.show {
        opacity: 1;
        pointer-events: all;
    }

    .login_card {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 240px;
        height: 320px;
        background: url("@/assets/global/login_bg.png") no-repeat center;
        background-size: cover;

        .login_close {
            right: 10px;
            top: 10px;
            width: 14px;
            height: 14px;
        }

        .card_top {
            height: 105px;

            .top_icon {
                width: 28px;
                height: 28px;
            }

            .top_title {
                margin-top: 10px;
                margin-bottom: 5px;
                color: #fff;
                font-size: 12px;
            }

            .top_desc {
                font-size: 10px;
                color: #fff;
            }
        }

        .card_bottom {
            flex: 1;
            padding: 0 24px;

            .bottom_qrcode {
                width: 80px;
                height: 80px;
                border: 1px solid #ccc;
                border-radius: 10px;
                overflow: hidden;

                .qrcode {
                    width: 70px;
                    height: 70px;
                }

                .code_reset {
                    top: 0;
                    left: 0;
                    border-radius: 10px;
                    background-color: rgba(255, 255, 255, .9);

                    .reset {
                        .reset_img {
                            width: 20px;
                            height: 20px;
                        }

                        .reset_text {
                            font-size: 10px;
                        }
                    }
                }
            }

            .bottom_tip {
                font-size: 10px;
                color: #333;
                margin-top: 25px;
                margin-bottom: 20px;
                line-height: 12px;

                span {
                    color: #A660FF;
                    font-weight: bold;
                }
            }

            .bottom_about {
                font-size: 10px;
                color: #808080;

                span {
                    cursor: pointer;
                    color: #A660FF;
                }
            }
        }
    }

    .login_success_screen {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 200px;
        height: 154px;
        background-color: #fff;
        border-radius: 16px;
        padding: 14px 22px;

        .success_ico {
            width: 48px;
            height: 48px;
            margin-bottom: 4px;
        }

        .success_name {
            color: #333;
            margin-bottom: 4px;
        }

        .success_msg {
            font-size: 10px;
            color: #333;
        }

        .success_btn {
            width: 92px;
            height: 24px;
            font-size: 10px;
            color: #fff;
            line-height: 24px;
            border-radius: 6px;
            background-color: #A660FF;
        }
    }
}
</style>
